// src/components/Services.js
import React from "react";

const services = [
  {
    icon: "🗄️",
    title: "Data Engineering",
    desc: "Build robust, scalable ETL pipelines and modern data platforms using Apache Spark, Azure Databricks, and cloud-native technologies.",
    tags: ["Apache Spark", "Azure Databricks", "SQL", "Python"],
    featured: true,
  },
  {
    icon: "🌐",
    title: "Website Development",
    desc: "High-performance, SEO-optimized responsive websites built with React and modern frameworks that convert visitors into customers.",
    tags: ["React", "Next.js", "Node.js", "Tailwind"],
    featured: false,
  },
  {
    icon: "📱",
    title: "Mobile Applications",
    desc: "Cross-platform mobile apps for iOS and Android using Flutter and React Native — built for speed, usability, and performance.",
    tags: ["Flutter", "React Native", "iOS", "Android"],
    featured: false,
  },
  {
    icon: "📈",
    title: "Digital Marketing",
    desc: "Grow your brand online with data-driven digital marketing — SEO, Google Ads, Social Media, content strategy, and performance campaigns.",
    tags: ["SEO", "Google Ads", "Social Media", "Content"],
    featured: true,
  },
  {
    icon: "🛒",
    title: "E-commerce Platforms",
    desc: "Secure and scalable online stores with seamless payment gateways, inventory management, and conversion-optimized design.",
    tags: ["Shopify", "WooCommerce", "Payment Gateway", "UX"],
    featured: false,
  },
  {
    icon: "📊",
    title: "Analytics & Dashboards",
    desc: "Transform raw data into clear business insights using BI dashboards, custom reports, and real-time analytics platforms.",
    tags: ["Power BI", "Tableau", "Python", "Data Lake"],
    featured: false,
  },
  {
    icon: "🔍",
    title: "SEO & Content Marketing",
    desc: "Rank higher on Google, drive organic traffic and build your authority with expert SEO audits, keyword strategy, and content creation.",
    tags: ["On-Page SEO", "Technical SEO", "Blogs", "Backlinks"],
    featured: false,
  },
  {
    icon: "💼",
    title: "Web Applications",
    desc: "Custom full-stack web applications designed for scale, security, and performance — from dashboards to enterprise SaaS platforms.",
    tags: ["Full Stack", "REST API", "Cloud Deploy", "Security"],
    featured: false,
  },
];

function Services() {
  return (
    <section className="services" id="services">
      <div className="section-inner">
        <div className="section-header">
          <div className="section-tag">
            <i className="fas fa-th-large"></i> Our Services
          </div>
          <h2 className="section-title">Everything Your Business Needs to Win Online</h2>
          <p className="section-subtitle">
            From building powerful data systems to crafting stunning websites and growing your brand digitally —
            we are your one-stop technology partner.
          </p>
        </div>

        <div className="services-grid">
          {services.map((s, i) => (
            <div className={`service-card ${s.featured ? "featured" : ""}`} key={i}>
              <div className="service-icon">{s.icon}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
              <div className="service-tags">
                {s.tags.map((t, j) => (
                  <span className="service-tag" key={j}>{t}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
